const LOCATION_NOT_CAPTURED_MESSAGE = 'No se capturó la ubicación.'
const LOCATION_ACCESS_DENIED_MESSAGE =
  'El usuario no permitió el acceso a la ubicación.'
const CAPTURE_SERVICE_ERROR_MESSAGE = 'Hubo un error en el servicio de captura.'
const TEAM_LOCATION_CAPTURE_ERROR_MESSAGE = 'No se pudo capturar la ubicación del equipo.'

const buildMessageList = (detail) => [LOCATION_NOT_CAPTURED_MESSAGE, detail]

export const getActivityMapMobileCaptureErrorMessage = (hasAllowedLocation) =>
  hasAllowedLocation === false
    ? `${TEAM_LOCATION_CAPTURE_ERROR_MESSAGE} porque no se otorgó permiso.`
    : TEAM_LOCATION_CAPTURE_ERROR_MESSAGE

export const getActivityMapMobileErrorMessages = ({
  errorCoordinatesCode,
  hasAllowedLocation
}) => {
  if (errorCoordinatesCode === 1) {
    return buildMessageList(LOCATION_ACCESS_DENIED_MESSAGE)
  }

  if (errorCoordinatesCode === 2) {
    return buildMessageList('Falló uno de los servicios usados para obtener la posición.')
  }

  if ([0, 3, 4].includes(errorCoordinatesCode)) {
    return buildMessageList(CAPTURE_SERVICE_ERROR_MESSAGE)
  }

  if (hasAllowedLocation === null) {
    return LOCATION_NOT_CAPTURED_MESSAGE
  }

  if (hasAllowedLocation === true) {
    return 'No se pudo enviar la ubicación de la actividad. Contacte a soporte.'
  }

  return getActivityMapMobileCaptureErrorMessage(hasAllowedLocation)
}

export const TIMESTAMP_MAP_MOBILE_ERROR_MESSAGES = [
  LOCATION_NOT_CAPTURED_MESSAGE,
  LOCATION_ACCESS_DENIED_MESSAGE
]

export const CLIENT_MAP_MOBILE_ERROR_MESSAGES = [
  'No se encontró una ubicación registrada para este cliente.',
  'Puede que la dirección aún no se haya ingresado en el sistema.'
]
